export default "__VITE_ASSET__ip5CGo2u__"